export default __webpack_public_path__ + "static/En_ELIB_iMedical_ClaimGuide-7d49daa930a38f34fd661cdcca506717.pdf";